import { IPlacementLocation, PathDetailLocationService } from 'capability-ng-todos';

export class MyTodosPlacementTestsController {
  taskDetails: any;
  placementData: any;
  placementTask: any;
  placementLocations: IPlacementLocation[];
  expectItem: any;

  constructor(
    private pathTaskDetail: any,
    private pathDetailLocationService: PathDetailLocationService,
    private placementTestScores: any,
    private PlacementEnum: any
  ) {
    this.taskDetails = this.pathTaskDetail;
    this.placementData = this.placementTestScores;
    this.placementLocations = this.placementTestLocations(this.placementData.placement_locations);
    this.placementTask = this.pathTaskDetail.source.task;
    this.expectItem = _.find(this.taskDetails.source.items, {
      nk: this.PlacementEnum.EI_PLACEMENT_TEST_WHAT_TO_EXPECT.value
    });
  }

  private placementTestLocations(placementLocations: IPlacementLocation[]): IPlacementLocation[] {
    return this.pathDetailLocationService.getFormattedLocations(placementLocations);
  }
}



// WEBPACK FOOTER //
// ./app/lib/my_todos/views/my_todos_placement_tests/my_todos_placement_tests_controller.ts